/**************************************************************
 handles featured components enabled with data-featured
 **************************************************************/

class FeaturedDialog {

  dialogElement = null;

  static selector = "dialog[data-featured]";

  static initialize() {
    const instances = [];

    document.querySelectorAll(FeaturedDialog.selector).forEach((dialog) => {
      const instance = new FeaturedDialog(dialog);
      instances.push(instance);
    });

    return instances;
  }

  constructor(element) {
    this.dialogElement = element;

    this.dialogElement.addEventListener("click", (event) => {
      if (event.target === this.dialogElement) {
        this.dialogElement.close();
      }
    });
    this.dialogElement.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.dialogElement.close();
      }
    });
    this.dialogElement.querySelectorAll("[data-featured-close]").forEach(element => {
      element.addEventListener("click", () => {
        this.dialogElement.close();
      });
    });

    window.Featured = window.Featured || {};
    window.Featured.dialogs = window.Featured.dialogs || [];
    window.Featured.dialogs.push(this);
  }

  showModal() {
    this.dialogElement?.showModal();
  }

}

/**********************************************************
 launch all classes
 **********************************************************/

const instances = FeaturedDialog.initialize();

